// Lib
import React, { CSSProperties } from 'react';

// Components
import ImageModalDrawingModeContent from '../../content/ImageModalDrawingModeContent';
import ImageModalV2CropModeContent from './ImageModalV2CropModeContent';

// Hooks
import { ImageModalV2Mode } from '../hooks/useImageModalV2Mode';

// Types
import { ImageModalV2EditModeProps } from '../imageModalV2Types';

type ImageModalV2EditModeContentProps = ImageModalV2EditModeProps & {
    mode: ImageModalV2Mode;
    contentStyle: CSSProperties;
    imageWrapperStyle: CSSProperties;
};

/**
 * Renders the active editor over the stable V2 image bounds.
 */
const ImageModalV2EditModeContent: React.FC<ImageModalV2EditModeContentProps> = ({
    mode,
    contentStyle,
    imageWrapperStyle,
    ...editModeProps
}) => {
    const fittedImageWidth = Number(imageWrapperStyle.width);
    const fittedImageHeight = Number(imageWrapperStyle.height);
    const captionHeight = Math.max(Number(contentStyle.height) - fittedImageHeight, 0);

    switch (mode) {
        case ImageModalV2Mode.DRAW:
            return (
                <div className="ImageModalV2-edit-overlay absolute inset-0 z-[1] flex items-center justify-center">
                    <div className="ImageModalV2-drawing-overlay relative" style={contentStyle}>
                        <div
                            className="ImageModalV2-drawing-canvas absolute top-0 left-0"
                            style={{
                                width: imageWrapperStyle.width,
                                height: imageWrapperStyle.height,
                            }}
                        >
                            <ImageModalDrawingModeContent {...editModeProps} modalWidth={fittedImageWidth} />
                        </div>
                    </div>
                </div>
            );
        case ImageModalV2Mode.CROP:
            return (
                <div className="ImageModalV2-edit-overlay absolute inset-0 z-[1] flex items-center justify-center">
                    <ImageModalV2CropModeContent
                        {...editModeProps}
                        fittedImageWidth={fittedImageWidth}
                        fittedImageHeight={fittedImageHeight}
                        captionHeight={captionHeight}
                    />
                </div>
            );
        case ImageModalV2Mode.VIEW:
        case ImageModalV2Mode.UPLOAD:
        case ImageModalV2Mode.DOWNLOAD:
            return null;
    }
};

export default ImageModalV2EditModeContent;
